module.exports = __webpack_public_path__ + "static/feature-user1-84be84f454742eddd81dff340ca7d03c.png";